import { render, staticRenderFns } from "./disputes-list.vue?vue&type=template&id=6477d283"
import script from "./disputes-list.vue?vue&type=script&lang=js"
export * from "./disputes-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports